
export class GetTZDAllActiveDDLList {
  static readonly type = "DDL Get";
}